import React from 'react';

import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import {
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
} from '@tmap/mmm-style-guide/src/Icon';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import Link from 'next/link';
import { useRouter } from 'next/router';
import addObjectParamsToPath from '../lib/addObjectParamsToPath';

const NumberedButton = styled(Button)(({ theme }) => ({
  '& button': {
    borderRadius: '64px',
    padding: 0,
    minWidth: 36,
    [theme.breakpoints.only('xs')]: {
      minWidth: 30,
    },
  },
}));

const StyledText = styled(Typography)(({ theme }) => ({
  minWidth: 36,
  lineHeight: '36px',
  [theme.breakpoints.only('xs')]: {
    minWidth: 30,
    lineHeight: '30px',
  },
}));

const BumperButton = styled(Button)(({ theme }) => ({
  '& button': {
    borderRadius: '64px',
    minWidth: 36,
    minHeight: 36,
    padding: 0,
    [theme.breakpoints.only('xs')]: {
      minWidth: 30,
      minHeight: 30,
    },
  },
}));

function Pager(props) {
  const {
    maxPage,
    reach = 2,
    spacing = { xs: 1, sm: 2 },
  } = props;

  const router = useRouter();

  let { page: currentPage = '1' } = router.query;
  currentPage = parseInt(currentPage, 10);

  const canPageBack = () => currentPage > 1;
  const canPageForward = (i) => i < maxPage;
  const isCurrentPage = (i) => currentPage === i;

  const getPageLink = (page) => addObjectParamsToPath(router.pathname, { ...router.query, page });

  if (maxPage === 0) return null;

  const numberedButtons = [];
  for (
    let i = Math.max(1, currentPage - reach);
    i <= (currentPage + reach) && canPageForward(i - 1);
    i++
  ) {
    numberedButtons.push(
      <Grid item key={i}>
        <NumberedButton {...(isCurrentPage(i) ? { color: 'secondary', variant: 'contained' } : { color: 'inverted', variant: 'text' })}>
          <Link href={getPageLink(i)}>
            <StyledText>{i}</StyledText>
          </Link>
        </NumberedButton>
      </Grid>,
    );
  }

  return (
    <Grid container justifyContent='center' spacing={spacing}>
      <Grid item>
        <BumperButton
          color='secondary'
          disabled={!canPageBack()}
          onClick={() => router.push(getPageLink(1))}
        >
          <FirstPage />
        </BumperButton>
      </Grid>
      <Grid item>
        <BumperButton
          color='secondary'
          disabled={!canPageBack()}
          onClick={() => router.push(getPageLink(currentPage - 1))}
        >
          <ChevronLeft />
        </BumperButton>
      </Grid>
      {numberedButtons}
      <Grid item>
        <BumperButton
          color='secondary'
          disabled={!canPageForward(currentPage)}
          onClick={() => router.push(getPageLink(currentPage + 1))}
        >
          <ChevronRight />
        </BumperButton>
      </Grid>
      <Grid item>
        <BumperButton
          color='secondary'
          disabled={!canPageForward(currentPage)}
          onClick={() => router.push(getPageLink(maxPage))}
        >
          <LastPage />
        </BumperButton>
      </Grid>
    </Grid>
  );
}

export default Pager;
